import { PartialDoctorSignature } from "../../partials/doctorSignature";

export const customRequest = {
  name: "Documento personalizado",
  gender: "female",
  fields: {
    title: {
      label: "Titulo do documento",
      type: "text",
      required: true,
      defaultPreview: _.range(30).fill("_").join(""),
    },
  },
  partials: {
    doctorSignature: {
      defaultValue: true,
      partial: PartialDoctorSignature,
    },
  },
  content: `
    <h1>{{title}}</h1>
    <div class="empty-page"></div>
    {{#doctorSignature}}
      {{>doctorSignature}}
    {{/doctorSignature}}
  `.trim(),
};
